import { defineStore } from 'pinia';
import {doGetCurrUserInfo} from "@/apis/LoginApi";
export const useUserStore = defineStore('user', {
  state: () => ({
    token: '',
    userInfo: {
      avatar: null,
      nickname: '',
    },
    roles:[],
    permissions:[],
  }),
  persist: {
    enabled: true,
    type: 'db',
    key: 'user_key',
    paths: ['token'],
    beforeRestore: () => {
      console.log('beforeRestore');
    },
    afterRestore: () => {
      console.log('afterRestore');
    },
  },
  getters: {
    // 获取用户信息
    getUserInfo() {
      return this.userInfo;
    },
    getToken(){
      return this.token;
    }
  },
  actions: {
    // 获取用户信息
    async loadUserInfo() {
      const res = await doGetCurrUserInfo();
      console.log("doGetCurrUserInfo",res);
      if (res.code === 0) {
        this.updateUserInfo(res.data);
        return res.data;
      }else {
        throw new Error("加载用户信息异常")
      }
    },
    // 更新用户信息
    updateUserInfo(userInfo) {
      if(userInfo===null){
        this.clearUserInfo();
      }else {
        console.log("updateUserInfo",userInfo);
        this.userInfo = { ...this.userInfo, ...userInfo.user };
        this.roles=userInfo.roles;
        this.permissions=userInfo.permissions;
      }

    },
    // 更新token
    updateToken(token) {
      this.token = token;
    },
    // 清空token
    clearToken() {
      this.token = '';
    },
    // 清空用户信息
    clearUserInfo() {
      this.userInfo = {}
      this.roles=[];
      this.permissions=[];
    }

  },
});